// アップニーク事前問診の選択肢キー定義。
// 14 問のラジオ／チェックボックスに対する選択肢を string literal の配列で持ち、
// 派生の type を export することで patient（フォーム入力）と clinic（表示）で
// 同じキーを共有する。表示用ラベルは各アプリ側で持つ（i18n / ハードコード）。
// Q1: 過去に眼瞼（まぶた）の手術歴はありますか？
export const Q1_OPTIONS = ["yes", "no"];
// Q2: まぶたが下がり始めたのはいつですか？
export const Q2_OPTIONS = [
    "withinWeek",
    "withinThreeMonths",
    "withinYear",
    "moreThanYear",
    "unsure",
];
// Q3: 下がっているのは、どちらのまぶたですか？
export const Q3_OPTIONS = [
    "leftOnly",
    "rightOnly",
    "bothEqual",
    "bothLeftStronger",
    "bothRightStronger",
];
// Q4: 時間帯や1日の中で変化はありますか？
export const Q4_OPTIONS = [
    "noChange",
    "worseInEvening",
    "worseAtNight",
    "irregular",
];
// Q5: まぶたが下がることで困っている症状はありますか？
export const Q5_OPTIONS = [
    "eyesHardToOpen",
    "heavyEyelids",
    "droopingVisionImpaired",
    "upperFieldImpaired",
    "liftEyebrows",
    "liftChin",
    "shoulderHeadFatigue",
    "doubleFoldWidened",
    "fingerLift",
    "appearanceChanged",
    "none",
    "other",
];
export const Q5_EXCLUSIVE = "none";
export const Q5_OTHER = "other";
// Q6: 最近、以下の症状はありますか？
export const Q6_OPTIONS = [
    "suddenPtosis",
    "doubleVision",
    "eyeMovement",
    "pupilSizeDiff",
    "severeHeadache",
    "eyePain",
    "neckPain",
    "limbNumbness",
    "slurredSpeech",
    "swallowingDifficulty",
    "breathingDifficulty",
    "afternoonWorse",
    "muscleWeakness",
    "none",
];
export const Q6_EXCLUSIVE = "none";
// Q7: まぶたの下がりについて、これまでに医療機関を受診したことはありますか？
export const Q7_OPTIONS = ["yes", "no"];
// Q7 サブ質問: 受診結果（「ある」選択時のみ、複数選択可）
export const Q7_RESULT_OPTIONS = [
    "noAbnormality",
    "neuromuscular",
    "examPending",
    "examScheduled",
    "dontRemember",
];
// Q8: 今回、使用を希望される理由を教えてください。
export const Q8_OPTIONS = [
    "droopingVisionImpaired",
    "eyesHardToOpen",
    "heavyEyelids",
    "liftEyebrowsOrChin",
    "eyeFatigueAndPain",
    "appearanceChanged",
    "fingerLift",
    "other",
];
export const Q8_OTHER = "other";
// Q9: 使用頻度の希望を教えてください。
export const Q9_OPTIONS = ["daily", "specialDay", "consultDoctor"];
// Q10: 以下の病気や状態を指摘されたことはありますか？
export const Q10_OPTIONS = [
    "hypertension",
    "hypotension",
    "orthostaticHypotension",
    "anginaInfarction",
    "arrhythmia",
    "heartFailure",
    "strokeOrHemorrhage",
    "closedAngleGlaucoma",
    "narrowAngle",
    "highIntraocular",
    "none",
    "dontKnow",
];
export const Q10_NONE = "none";
export const Q10_DONT_KNOW = "dontKnow";
// Q11: 現在、以下のお薬を使用していますか？
export const Q11_OPTIONS = [
    "bloodPressureDrug",
    "heartDrug",
    "prostateDrug",
    "antidepressantPsychiatric",
    "maoInhibitor",
    "other",
    "dontKnow",
    "notUsing",
];
export const Q11_OTHER = "other";
export const Q11_DONT_KNOW = "dontKnow";
export const Q11_NOT_USING = "notUsing";
// Q12: 薬や食べ物でアレルギー反応や違和感を起こしたことはありますか？
export const Q12_OPTIONS = ["yes", "no", "unsure"];
// Q13: 現在コンタクトレンズは使用されていますか？
export const Q13_OPTIONS = ["notUsing", "using"];
export const Q13_TYPE_OPTIONS = [
    "hard",
    "soft1day",
    "soft2week",
    "other",
];
export const Q13_PERIOD_OPTIONS = [
    "lessThanYear",
    "oneToThree",
    "threeToFive",
    "moreThanFive",
];
export const Q13_FREQUENCY_OPTIONS = [
    "almostDaily",
    "weekly",
    "occasionally",
];
// Q14: 妊娠または授乳をされていますか？
export const Q14_OPTIONS = ["no", "pregnant", "breastfeeding"];
export const QUESTION_COUNT = 14;
/**
 * 各質問の questionIndex（API スキーマ上の識別子）。
 * `Answers.qN` のキー名と一致させ、フォーム入力 ↔ API ↔ 表示の対応関係を
 * 単一の真実源で管理する。
 *
 * sub-question の番号（Q7/Q12/Q13 内の 1, 2, 3 等）は各 Q 内のローカル序列
 * のためここには含めず、利用箇所のコメントで補足する。
 */
export const QUESTION_INDEX = {
    q1: 1,
    q2: 2,
    q3: 3,
    q4: 4,
    q5: 5,
    q6: 6,
    q7: 7,
    q8: 8,
    q9: 9,
    q10: 10,
    q11: 11,
    q12: 12,
    q13: 13,
    q14: 14,
};
